import { CreatableTemplateStatus } from '../../../../store/types/template';

export type SaveIntent = 'draft' | 'publish' | 'save';

export type SaveAction = {
  /**
   * `blocked` — the plan has no published slot left, show the upgrade modal.
   * `validate` — show the save-validation modal before going any further.
   * `confirm` — publishing is clean, ask the user to confirm first.
   * `save` — go straight to the API.
   */
  action: 'blocked' | 'validate' | 'confirm' | 'save';
  /** Status to send with the request; `undefined` leaves the status untouched. */
  status?: CreatableTemplateStatus;
  /** Which copy the validation modal should use. */
  validationMode: 'draft' | 'publish';
};

/**
 * Decides what a builder submit should do, given which button was pressed and
 * what validation found. Kept pure so the branching is testable without
 * standing up the whole builder.
 */
export const resolveSaveAction = ({
  intent,
  hasIssues,
  isLimitReached,
}: {
  intent: SaveIntent;
  hasIssues: boolean;
  isLimitReached: boolean;
}): SaveAction => {
  if (intent === 'publish') {
    // Publishing always consumes a published-template slot.
    if (isLimitReached) return { action: 'blocked', validationMode: 'publish' };
    return {
      action: hasIssues ? 'validate' : 'confirm',
      status: 'published',
      validationMode: 'publish',
    };
  }

  if (intent === 'draft') {
    return {
      action: hasIssues ? 'validate' : 'save',
      status: 'draft',
      validationMode: 'draft',
    };
  }

  // intent === 'save' — editing an already-published template.
  return {
    action: hasIssues ? 'validate' : 'save',
    validationMode: 'publish',
  };
};
